import { render, staticRenderFns } from "./miantabbar.vue?vue&type=template&id=dc3b655a&scoped=true"
import script from "./miantabbar.vue?vue&type=script&lang=js"
export * from "./miantabbar.vue?vue&type=script&lang=js"
import style0 from "./miantabbar.vue?vue&type=style&index=0&id=dc3b655a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3b655a",
  null
  
)

export default component.exports